import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";

import { Table, TableBody, TableHead, TableCell, TableContainer, TableRow } from '@mui/material';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import { getLiftOpLogsQuery } from 'components/axios/equipmentAxios';

import dayjs from 'dayjs';
import PageInfo from 'components/PageInfo';

const EquipmentPanel = ({equipment}) => {
  const { t } = useTranslation();

  const [pnTab, setPnTab] = useState('1');
  const [isLoading, setIsLoading] = useState(false);

  let [pageInfo, setPageInfo] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);

  const handlePaging = (value) => {
      value = isNaN(value) ? 1 : value;
      setCurrentPage(value-1);
      setIsLoading(false);
  }

  const [liftOpControlLogs, setLiftOpControlLogs] = useState([]); // 제어반 상태 목록
  const [liftOperationLogs, setLiftOperationLogs] = useState([]); // 운전상태 이력 목록

  useEffect(() => {
    // console.log('load')
    if (!isLoading && !isNaN(currentPage) && equipment) {
      liftOpLogList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, isLoading, equipment]);

  const liftOpLogList = async(curPage=currentPage) => {
    isNaN(curPage) && setCurrentPage(0);
    isNaN(pageSize) && setPageSize(20);
    let param = {
        page: curPage,
        size : pageSize,
    };
    param["equipment.id"] = equipment.id;
    
    let param2 = {...param};
    param2["controlPanelCode.usrDfnCd"] = "isNotNull()";
    console.log(param2);

    Promise.all([
      getLiftOpLogsQuery(param).then((data)=>{
        return data;
      }),
      getLiftOpLogsQuery(param2).then((data)=>{
        return data;
      })
    ]).then((res)=>{
      // 운전상태이력
      if (res[0]) {
        if (res[0].page) {
          setPageInfo(res[0].page);
        } else {
            setCurrentPage(0);
            pageInfo = {
                size: pageInfo.size,
                totalElements: 0,
                totalPages: 0,
                number: 0
            };
            setPageInfo(pageInfo);
        }
        setLiftOperationLogs(res[0]._embedded?.equipmentOpLogs);
      } else {
        pageInfo = {
          size : pageInfo.size,
          totalElements : 0,
          totalPages : 0,
          number : 0
        }
        setPageInfo(pageInfo);
        setLiftOperationLogs([]);
      }

      // 제어반 상태 목록
      if (res[1]) {
        if (res[1].page) {
          setPageInfo(res[1].page);
        } else {
            setCurrentPage(0);
            pageInfo = {
                size: pageInfo.size,
                totalElements: 0,
                totalPages: 0,
                number: 0
            };
            setPageInfo(pageInfo);
        }
        setLiftOpControlLogs(res[1]._embedded?.equipmentOpLogs);
      } else {
        pageInfo = {
          size : pageInfo.size,
          totalElements : 0,
          totalPages : 0,
          number : 0
        }
        setPageInfo(pageInfo);
        setLiftOpControlLogs([]);
      }
    })

    setIsLoading(true);
  }

  const selectPanel = (event, newValue1) => {
    setPnTab(newValue1);
    setCurrentPage(0);
    pageInfo.number = 0;
    setPageInfo(pageInfo);
    liftOpLogList(0);
    // setIsLoading(false);
  };

  if (isLoading) {
  return (
        <Box sx={{ width: '100%', typography: 'body1' }} className="control_panel">
          <TabContext value={pnTab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className="">
              <TabList onChange={selectPanel} aria-label="lab API tabs example">
                <Tab className="tabsall" label={t('message.common.title.control.panel.status')} value="1" />
                <Tab className="tabsline1" label={t('message.common.title.operation.status.history')} value="2" />
              </TabList>
            </Box>
            <TabPanel value="1" style={{display:"flex"}}>
              <div className='cn_dash_tabbox liftControlPanel'>
                <TableContainer>
                  <Table sx={{ minWidth: 800 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>{t('message.common.subtitle.inspection.datetime')}</TableCell>
                        <TableCell>{t('message.common.subtitle.occurrence.code')}</TableCell>
                        <TableCell>{t('message.common.subtitle.error.message')}</TableCell>
                        <TableCell>{t('message.common.subtitle.status')}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {liftOpControlLogs && liftOpControlLogs.map((log, l)=>{
                        let tdFontColorClassName = '';
                        if (log?.controlPanelCode?.alertYn === 'Y') {tdFontColorClassName = ' font_red';}
                        return (
                      <TableRow key={l} className={`pop_tr${tdFontColorClassName}`}>
                        <TableCell>{dayjs(log?.createdAt).format('YYYY-MM-DD HH:mm:ss')}</TableCell>
                        <TableCell>{log?.controlPanelCode?.usrDfnCd}</TableCell>
                        <TableCell>{log?.controlPanelCode?.statusMsg}</TableCell>
                        <TableCell>{log?.controlPanelCode?.alertYn === 'Y' ? t('message.common.warning') : t('message.common.normal')}</TableCell>
                      </TableRow> 
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <PageInfo pageInfo={pageInfo} handlePaging={handlePaging} />
              </div>
            </TabPanel>
            <TabPanel value="2" style={{display:"flex"}}>
              <div className='cn_dash_tabbox'>
                <TableContainer>
                  <Table sx={{ minWidth: 800 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>{t('message.common.subtitle.inspection.datetime')}</TableCell>
                        <TableCell>{t('message.common.subtitle.mode')}</TableCell>
                        <TableCell>{t('message.common.subtitle.status')}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {liftOperationLogs && liftOperationLogs.map((log, l)=>{
                        return (
                      <TableRow key={l} className='pop_tr'>
                        <TableCell>{dayjs(log?.createdAt).format('YYYY-MM-DD HH:mm:ss')}</TableCell>
                        <TableCell>{log.opMode?.integratedName}</TableCell>
                        <TableCell>{log.opStatus}</TableCell>
                      </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>
              </div>
            </TabPanel>
          </TabContext>
        </Box>
    )
  }
}

export default EquipmentPanel;
